import {toast} from "react-toastify";
import './ReactToastify.css';

export const TOAST_SUCCESS = 1;
export const TOAST_FAILURE = 2;
export const TOAST_WARNING = 3;

export const clearAllToasts = () => {
    toast.dismiss();
};

export const showToast = (data, type, options = {}) => {
    const config = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        ...options,
    };

    // When a toastId is supplied, skip if a toast with that id is already
    // on screen. This dedupes bursts of identical toasts (e.g. several
    // parallel requests all failing because the server is unreachable).
    if (config.toastId && toast.isActive(config.toastId)) {
        return;
    }

    if(type === TOAST_SUCCESS) {
        toast.success(data, config);
    } else if(type === TOAST_FAILURE) {
        toast.error(data, config);
    }else if(type === TOAST_WARNING) {
        toast.warn(data, config);
    }
};
